module.exports = __webpack_public_path__ + "static/logo-small-39a9042eacce26380ab958496b42da67.png";